// Re-sync the cart after Back/Forward navigation. A browser can show a cached copy
// of a page on Back, for example after a shopper adds a discount code at checkout,
// and that copy shows the old cart: the free shipping bar can read "unlocked" when
// checkout will charge shipping. The theme only refreshes the drawer on a
// back/forward cache restore, and never refreshes the cart page.
(function () {
  const isCartPage = () => window.themeVariables?.settings?.pageType === "cart";
  const navigation = performance.getEntriesByType?.("navigation")?.[0];

  // transferSize is 0 when the page came from the browser cache rather than the
  // network. Treat an unsupported value as cached so older browsers still re-sync.
  if (navigation?.type === "back_forward" && !(navigation.transferSize > 0)) {
    if (isCartPage()) {
      // Matches the theme, which reloads the cart page after every cart change.
      window.location.reload();
    } else {
      // Re-renders the cart drawer (including its free shipping bar) and cart count.
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
  }

  // A back/forward cache restore keeps the old cart page as is. The theme already
  // refreshes the drawer in that case, so only the cart page needs a reload.
  window.addEventListener("pageshow", (event) => {
    if (event.persisted && isCartPage()) {
      window.location.reload();
    }
  });
})();

// (function() {
//   const seen = new Set();
//   const origDispatch = EventTarget.prototype.dispatchEvent;

//   EventTarget.prototype.dispatchEvent = function(event) {
//     if (!seen.has(event.type)) {
//       seen.add(event.type);
//       console.log("%c🔥 Event fired:", "color: orange", event.type, "on", this);
//     }
//     return origDispatch.call(this, event);
//   };

//   console.log("%cGlobal event logger active (will log unique events only)", "color: lightgreen");
// })();

//   console.log("%cEvent logger active... Ignoring common events", "color: lightgreen");
// })();

// (function() {
//   const reloadEvents = [
//     "event-subscribers:setup",
//     "update-event-listeners",
//     "wk:state:refetch",
//     "wk:state:action",
//     "listbox:change"
//   ];

//   reloadEvents.forEach(ev => {
//     window.addEventListener(ev, () => {
//       console.log("%c[window] Yotpo refresh after " + ev, "color: orange");
//     });

//     document.addEventListener(ev, () => {
//       console.log("%c[document] Yotpo refresh after " + ev, "color: lightblue");
//     });
//   });
// })();

(function() {
  function refreshYotpo(evName) {
    console.log("⏳ Trying Yotpo refresh after:", evName);

    setTimeout(() => {
      try {
        if (window.yotpoWidgetsContainer?.initWidgets) {
          //console.log("✅ Yotpo initWidgets() called");
          window.yotpoWidgetsContainer.initWidgets();
        } else if (window.yotpo?.refreshWidgets) {
          //console.log("✅ Yotpo refreshWidgets() called");
          window.yotpo.refreshWidgets();
        } else {
          console.log("❌ Yotpo API not available yet");
        }
      } catch (err) {
        console.error("⚠️ Error refreshing Yotpo:", err);
      }
    }, 0); // adjust delay if needed
  }

  // 🎯 Attach listener only to theme:loading:end
  document.addEventListener("theme:loading:end", () => refreshYotpo("theme:loading:end"));
})();

(function () {
  const optionSelector = ".popover__value-option-button, .popover__value-option a";

  function optionControls(list) {
    return Array.from(list.querySelectorAll(optionSelector)).filter((el) => !el.hidden);
  }

  function moveOptionFocus(list, current, delta) {
    const items = optionControls(list);
    if (!items.length) {
      return;
    }

    const index = Math.max(0, items.indexOf(current));
    const next = items[(index + delta + items.length) % items.length];
    next?.focus();
  }

  function selectOptionButton(button) {
    const radio = button.parentElement?.querySelector('input[type="radio"]');
    if (!radio) {
      return;
    }

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    button.closest("x-popover")?.hide?.();
  }

  function formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    const format = window.themeVariables?.settings?.moneyFormat || "${{amount}}";
    return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ","));
  }

  function announceVariant(event) {
    const variant = event.detail?.variant;
    const template = window.themeVariables?.strings?.variantSelected;
    if (!variant || !template) {
      return;
    }

    let availability = "";
    if (!variant.available) {
      availability = variant.id
        ? (window.themeVariables?.strings?.soldOut || "")
        : (window.themeVariables?.strings?.unavailable || "");
    }

    const message = template
      .replace("{{ title }}", variant.name || variant.title || "")
      .replace("{{ price }}", variant.price != null ? formatMoney(variant.price) : "")
      .replace("{{ availability }}", availability)
      .replace(/\.\s+$/, ".")
      .replace(/\.\s*\./g, ".")
      .trim();

    window.themeAnnounce?.(message);
  }

  function isVariantPopover(el) {
    return el instanceof Element && el.tagName === "X-POPOVER" && !!el.querySelector(".popover__value-option-button, .popover__value-option a");
  }

  function triggerForPopoverId(id) {
    return id ? document.querySelector(`button.select[aria-controls="${CSS.escape(id)}"]`) : null;
  }

  // Id of the size dropdown the last option change came from. Only a change made
  // inside a dropdown sends focus back to that dropdown's button; changing a
  // swatch or any other option leaves focus where the shopper put it.
  let changedFromPopoverId = "";

  document.addEventListener("click", (event) => {
    const button = event.target.closest?.(".popover__value-option-button");
    if (button) {
      selectOptionButton(button);
    }
  });

  document.addEventListener("keydown", (event) => {
    const list = event.target.closest?.(".popover__value-list");
    if (!list || !list.querySelector(".popover__value-option-button, .popover__value-option a")) {
      return;
    }

    const current = event.target.closest(optionSelector);
    if (!current || !list.contains(current)) {
      return;
    }

    const items = optionControls(list);
    if (!items.length) {
      return;
    }

    switch (event.key) {
      case "ArrowDown":
      case "ArrowRight":
        event.preventDefault();
        moveOptionFocus(list, current, 1);
        break;
      case "ArrowUp":
      case "ArrowLeft":
        event.preventDefault();
        moveOptionFocus(list, current, -1);
        break;
      case "Home":
        event.preventDefault();
        items[0]?.focus();
        break;
      case "End":
        event.preventDefault();
        items[items.length - 1]?.focus();
        break;
      default:
        break;
    }
  });

  document.addEventListener("dialog:after-show", (event) => {
    if (!isVariantPopover(event.target)) {
      return;
    }

    event.target.querySelector(".popover__value-list [aria-current='true']")?.focus();
  }, true);

  document.addEventListener("dialog:after-hide", (event) => {
    if (!isVariantPopover(event.target)) {
      return;
    }

    const trigger = triggerForPopoverId(event.target.id);
    if (!trigger) {
      return;
    }

    if (document.activeElement === document.body || event.target.contains(document.activeElement)) {
      trigger.focus();
    }
  }, true);

  document.addEventListener("change", (event) => {
    // The theme also fires change on the hidden variant id input before
    // variant:change, so only real option inputs may set or clear the marker.
    if (!(event.target instanceof HTMLInputElement) || !event.target.hasAttribute("data-option-position")) {
      return;
    }

    const popover = event.target.closest("x-popover");
    changedFromPopoverId = isVariantPopover(popover) ? popover.id : "";
  }, true);

  document.addEventListener("variant:change", (event) => {
    announceVariant(event);

    if (!changedFromPopoverId) {
      return;
    }

    // The product block has been re-rendered by now, so look the button up again.
    const popoverId = changedFromPopoverId;
    changedFromPopoverId = "";
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        triggerForPopoverId(popoverId)?.focus();
      });
    });
  });
})();

(function () {
  // Cart drawer focus. Opening the drawer puts focus on its heading, never on a
  // form control: landing in a quantity field let arrow keys change the cart.
  // The drawer re-renders its contents after every cart change, so the heading
  // and line items are looked up fresh each time instead of cached.
  function afterPaint(fn) {
    requestAnimationFrame(() => {
      requestAnimationFrame(fn);
    });
  }

  function cartDrawer() {
    return document.getElementById("cart-drawer");
  }

  function focusIsLost(drawer) {
    const active = document.activeElement;
    return !active || active === document.body || !active.isConnected || !drawer.contains(active);
  }

  function focusHeading(drawer) {
    const heading = drawer.querySelector("#cart-drawer-title");
    if (heading) {
      heading.focus({ preventScroll: true });
      return;
    }

    if (!drawer.hasAttribute("tabindex")) {
      drawer.setAttribute("tabindex", "-1");
    }

    drawer.focus({ preventScroll: true });
  }

  document.addEventListener("cart:change", () => {
    const drawer = cartDrawer();
    if (drawer) {
      drawer.dataset.ubjFocusId = drawer.open ? (document.activeElement?.id || "") : "";
    }
  }, true);

  document.addEventListener("dialog:after-show", (event) => {
    if (event.target?.id !== "cart-drawer") {
      return;
    }

    focusHeading(event.target);
  }, true);

  document.addEventListener("cart-drawer:refreshed", (event) => {
    const drawer = event.target;
    if (drawer?.id !== "cart-drawer" || !drawer.open) {
      return;
    }

    afterPaint(() => {
      if (!focusIsLost(drawer)) {
        return;
      }

      const savedId = drawer.dataset.ubjFocusId;
      const saved = savedId ? document.getElementById(savedId) : null;
      if (saved && saved !== drawer && drawer.contains(saved)) {
        saved.focus({ preventScroll: true });
        return;
      }

      focusHeading(drawer);
    });
  }, true);
})();

(function () {
  const MENU_ID = "sidebar-menu";
  const TEASER_NAME = /unlock\s+\d+\s*%?\s*off/i;
  const GUARD_MS = 1000;

  function afterPaint(fn) {
    requestAnimationFrame(() => {
      requestAnimationFrame(fn);
    });
  }

  function menuTrigger(preferExpanded) {
    if (preferExpanded) {
      const expanded = document.querySelector(`button[aria-controls="${MENU_ID}"][aria-expanded="true"]`);
      if (expanded) {
        return expanded;
      }
    }

    return document.querySelector(`button[aria-controls="${MENU_ID}"]`);
  }

  function isKlaviyoTeaser(el) {
    let node = el?.nodeType === Node.TEXT_NODE ? el.parentElement : el;
    while (node && node !== document.documentElement && node !== document.body) {
      if (node.matches?.('[class*="Teaser"], [class*="teaser"]')) {
        return true;
      }

      const name = `${node.getAttribute?.("aria-label") || ""} ${node.textContent || ""}`.replace(/\s+/g, " ").trim();
      if (name.length > 0 && name.length < 80 && TEASER_NAME.test(name)) {
        return true;
      }

      node = node.parentElement;
    }

    return false;
  }

  let lastMenuTrigger = null;
  let guard = null;

  function disarmGuard() {
    if (!guard) {
      return;
    }

    document.removeEventListener("focusin", guard.onFocusIn, true);
    document.removeEventListener("keydown", guard.disarm, true);
    document.removeEventListener("pointerdown", guard.disarm, true);
    document.removeEventListener("touchstart", guard.disarm, true);
    clearTimeout(guard.timer);
    guard = null;
  }

  function armGuard(trigger) {
    disarmGuard();
    if (!trigger) {
      return;
    }

    const onFocusIn = (event) => {
      if (!trigger.isConnected) {
        disarmGuard();
        return;
      }

      if (isKlaviyoTeaser(event.target)) {
        trigger.focus({ preventScroll: true });
      }
    };

    guard = { onFocusIn, disarm: disarmGuard };
    document.addEventListener("focusin", onFocusIn, true);
    document.addEventListener("keydown", disarmGuard, true);
    document.addEventListener("pointerdown", disarmGuard, true);
    document.addEventListener("touchstart", disarmGuard, true);
    guard.timer = setTimeout(disarmGuard, GUARD_MS);
  }

  document.addEventListener("dialog:before-hide", (event) => {
    if (event.target?.id !== MENU_ID) {
      return;
    }

    lastMenuTrigger = menuTrigger(true);
  }, true);

  document.addEventListener("dialog:after-hide", (event) => {
    if (event.target?.id !== MENU_ID) {
      return;
    }

    const trigger = lastMenuTrigger?.isConnected ? lastMenuTrigger : menuTrigger(false);
    afterPaint(() => {
      trigger?.focus({ preventScroll: true });
      armGuard(trigger);
    });
  }, true);
})();

(function () {
  // Pause and play for the rotating announcement bar (WCAG 2.2.2). The button is
  // only rendered when there is more than one message and autoplay is on.
  function setState(button, state) {
    button.dataset.state = state;
    button.querySelector('[data-autoplay-label="pause"]')?.toggleAttribute("hidden", state === "paused");
    button.querySelector('[data-autoplay-label="play"]')?.toggleAttribute("hidden", state !== "paused");
  }

  function init(root) {
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    // The carousel starts stopped under reduced motion, so the button offers Play.
    root.querySelectorAll("[data-announcement-toggle]").forEach((button) => setState(button, "paused"));
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest?.("[data-announcement-toggle]");
    if (!button) {
      return;
    }

    const player = document.getElementById(button.getAttribute("aria-controls"))?.player;
    if (!player) {
      return;
    }

    if (button.dataset.state === "paused") {
      player.start();
      setState(button, "playing");
    } else {
      player.stop();
      setState(button, "paused");
    }
  });

  init(document);
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();

(function () {
  // The Google Customer Reviews app injects its badge as an untitled iframe on
  // every page (axe frame-title). Name it once it appears, then stop watching.
  const SELECTOR = 'iframe[src*="google.com/shopping"]:not([title])';
  const title = window.themeVariables?.strings?.googleReviewsBadge || "Google Customer Reviews badge";

  function nameFrames() {
    const frames = document.querySelectorAll(SELECTOR);
    frames.forEach((frame) => frame.setAttribute("title", title));
    return frames.length > 0;
  }

  if (nameFrames()) {
    return;
  }

  const observer = new MutationObserver(() => {
    if (nameFrames()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 30000);
})();

(function () {
  // Publish the product sticky bar's height so the scroll padding in custom.css
  // keeps focused elements clear of it (WCAG 2.4.11). The bar is replaced when a
  // variant change re-renders the product, so it is looked up again then.
  let observer = null;

  function track() {
    observer?.disconnect();
    const bar = document.querySelector(".product-sticky-bar");
    if (!bar) {
      return;
    }

    observer = new ResizeObserver(() => {
      document.documentElement.style.setProperty("--product-sticky-bar-height", `${Math.ceil(bar.getBoundingClientRect().height)}px`);
    });
    observer.observe(bar);
  }

  track();
  document.addEventListener("product:rerender", () => requestAnimationFrame(track), true);
  document.addEventListener("shopify:section:load", track);
})();

(function () {
  // A failed form submit reloads the page with an error banner. Move focus to
  // it so keyboard and screen reader users land on the message (WCAG 3.3.1).
  // Only visible banners inside forms count; pop-ins are handled when they open.
  const pageBanner = Array.from(document.querySelectorAll("form .banner--error[role='alert']"))
    .find((banner) => !banner.closest(".pop-in, newsletter-popup") && banner.getClientRects().length > 0);

  pageBanner?.focus();

  document.addEventListener("dialog:after-show", (event) => {
    const dialog = event.target;

    // Newsletter pop-in reopened after a failed submit: focus its error.
    if (dialog?.tagName === "NEWSLETTER-POPUP") {
      dialog.querySelector(".banner--error[role='alert']")?.focus();
      return;
    }

    // Quick buy: land on the modal heading, not the first form field, so arrow
    // keys cannot change a quantity or option by accident.
    if (dialog?.tagName === "QUICK-BUY-MODAL") {
      // The header slot title is hidden from 700px up; the product title shows instead.
      const target = Array.from(dialog.querySelectorAll('[slot="header"], .quick-buy-modal__info-wrapper .product-title'))
        .find((el) => el.getClientRects().length > 0) || dialog;
      target.setAttribute("tabindex", "-1");
      target.focus({ preventScroll: true });
    }
  }, true);
})();

